import { useState, useEffect } from 'react';
import { Play } from 'lucide-react';
import { META, ROUTES } from './data';

// Pelagic Header — black band with letterboxed feel. Brand left, route nav center, play indicator right.
export default function Header({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', h, { passive: true });
    return () => window.removeEventListener('scroll', h);
  }, []);
  return (
    <header className={`fixed top-0 inset-x-0 z-40 transition-all duration-700 ${scrolled ? 'bg-[#0A0908]/90 backdrop-blur-md py-2' : 'py-4'}`}>
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12 flex items-center justify-between gap-6">
        <button onClick={() => setPage('home')} className="flex items-center gap-3 text-[#FBF6E8]" data-testid="film-logo">
          <span className="font-serif italic text-2xl tracking-tight">{META.brand}</span>
          <span className="hidden sm:inline font-mono text-[9px] tracking-[0.35em] uppercase text-[#C9963E]/85 border-l border-[#FBF6E8]/15 pl-3">{META.tagline}</span>
        </button>
        <nav className="hidden md:flex items-center gap-9">
          {ROUTES.map((r, i) => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`film-nav-${r.id}`}
              className={`group flex items-center gap-2 font-mono text-[10px] tracking-[0.3em] uppercase transition-colors ${page === r.id ? 'text-[#C9963E]' : 'text-[#FBF6E8]/65 hover:text-[#FBF6E8]'}`}>
              <span className="opacity-60">0{i + 1}</span><span>{r.label}</span>
            </button>
          ))}
        </nav>
        <button onClick={() => setPage('brief')} className="flex items-center gap-2 bg-[#C9963E] text-[#0A0908] px-4 py-2 font-mono text-[10px] tracking-[0.3em] uppercase hover:bg-[#FBF6E8] transition-colors" data-testid="film-cta-brief">
          <Play className="w-3 h-3" fill="currentColor" /> Send brief
        </button>
      </div>
    </header>
  );
}
